import { CreditCardIcon, DollarIcon, HeartIcon, PersonIcon } from '@web/components/atoms/Icons'
import { Box, Flex } from '@web/components/atoms/Layout'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { DonationFormStep, useDonationFormContext } from '@web/components/page-components/DonationForm'

const DonationStepTabs = () => {
  const styles = useDonationFormContext((state) => state.settings.styles)
  const hasUpsellModuleStep = useDonationFormContext((state) =>
    Boolean(state.settings.styles?.options?.upsellRegularGivingOptions),
  )
  const accentColor = useColorWithOpacity(styles?.stepIndicatorColor, '1', 'var(--branding-button-primary-bg-color)')
  const step = useDonationFormContext((state) => state.step)
  const actions = useDonationFormContext((state) => state.actions)
  return (
    <Flex
      pb="-1px"
      borderBottom="1px solid #CBD5E0"
      w="100%"
      alignItems="center"
      justifyContent="center"
      css={{
        '& .c-donation-step-tab': {
          padding: '16px 24px',
          borderBottom: '1px solid transparent',
          marginBottom: '-1px',
          transition: 'all 0.3s ease-in-out',
          cursor: 'pointer',
        },
        '& .c-donation-step-tab.c-donation-step-tab--active': {
          color: accentColor,
          borderBottomColor: accentColor,
        },
      }}
    >
      <Box
        onClick={() => {
          actions.setStep(DonationFormStep.Step1)
        }}
        className={`c-donation-step-tab ${step >= DonationFormStep.Step1 || step === DonationFormStep.UpsellStep ? ' c-donation-step-tab--active' : ''}`}
      >
        <DollarIcon boxSize="24px" />
      </Box>
      {hasUpsellModuleStep && (
        <Box
          onClick={() => {
            if (step <= DonationFormStep.Step2) {
              return
            }

            actions.setStep(DonationFormStep.UpsellStep)
          }}
          className={`c-donation-step-tab ${step >= DonationFormStep.Step2 || step === DonationFormStep.UpsellStep ? ' c-donation-step-tab--active' : ''}`}
        >
          <HeartIcon boxSize="24px" />
        </Box>
      )}
      <Box
        onClick={() => {
          if (step <= DonationFormStep.Step2) {
            return
          }

          actions.setStep(DonationFormStep.Step2)
        }}
        className={`c-donation-step-tab ${step >= DonationFormStep.Step2 ? ' c-donation-step-tab--active' : ''}`}
      >
        <PersonIcon boxSize="24px" />
      </Box>
      <Box className={`c-donation-step-tab${step >= DonationFormStep.Step3 ? ' c-donation-step-tab--active' : ''}`}>
        <CreditCardIcon boxSize="24px" />
      </Box>
    </Flex>
  )
}

export default DonationStepTabs
